import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BlockDiagramEditorComponent } from './blockDiagramEditor/blockDiagramEditor.component';
import { FeaturesComponent } from './features/features.component';

const routes: Routes = [
  {
    path: 'block-diagram-editor',
    component: BlockDiagramEditorComponent,
    data: { title: 'noasy.menu.block-diagram-editor' }
  },
  {
    path: 'features',
    component: FeaturesComponent,
    data: { title: 'noasy.menu.features' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StaticRoutingModule {}
